import { render } from "./Clock.vue?vue&type=template&id=10aefdf0&scoped=true&ts=true"
import script from "./Clock.vue?vue&type=script&lang=ts"
export * from "./Clock.vue?vue&type=script&lang=ts"

import "./Clock.vue?vue&type=style&index=0&id=10aefdf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aefdf0"]])

export default __exports__